import axiosClient from './axiosClient';

const fileService = {
    // Add onProgress as a second parameter
    uploadFile: async (file, onProgress) => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await axiosClient.post('/file/single', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (event) => {
                // Check if onProgress was actually provided before calling it
                if (onProgress && event.total) {
                    const progress = Math.round((event.loaded * 100) / event.total);
                    onProgress(progress);
                }
            }
        });
        return response.data.file;
    }
};

export default fileService;
